// extracted by mini-css-extract-plugin
export default {"wrapper":"OzBHsHo2j3fs3fGOgajt","planInfosWrapper":"vuZgtHEuZmqiybuDxN99","planName":"zzbLHRntFrIElt4OE5ce","planInfos":"d4SMjjiGmQiAKKgS0lE1","avatars":"FpfttpWvYl5Kmu60N3cW"};